import { windowWidth } from './utils';

const accordian = {
  accordian: document.querySelectorAll(
    '.jsAccordian',
  ) as NodeListOf<HTMLElement>,
  scrollToEl: undefined as HTMLElement | undefined,
  init() {
    this.setAccordian();
  },
  setAccordian() {
    this.accordian.forEach((item) => {
      const width = item.dataset.width ? item.dataset.width : '999999';
      const offset = item.dataset.offset;

      if (windowWidth < parseInt(width)) {
        const items = item.querySelectorAll(
          '.jsAccordianItem',
        ) as NodeListOf<HTMLElement>;

        this.setItems(items);
        this.setMultipleToggle(item, items);
        if (offset) {
          item.addEventListener('transitionend', () => {
            this.scrollPosition(offset);
          });
        }
      }
    });
  },

  setItems(items: NodeListOf<HTMLElement>) {
    items.forEach((item) => {
      const parent = item.parentElement as HTMLElement;
      const sibiling = item.nextElementSibling as HTMLElement;
      const sibilingHeight = sibiling.offsetHeight;
      const height = item.offsetHeight;

      const faqButton =
        item.querySelector<HTMLButtonElement>('.ndis-faq__button');
      if (faqButton && item.closest('.ndis-faq')) {
        const renderFaq = () => {
          const isOpen = item.dataset.open === 'true';
          const titleHeight = item.offsetHeight;
          const answerHeight = sibiling.offsetHeight;
          parent.style.maxHeight = `${titleHeight + (isOpen ? answerHeight : 0)}px`;
          item.classList.toggle('activeClass', isOpen);
          parent.classList.toggle('activeClass', isOpen);
          faqButton.setAttribute('aria-expanded', String(isOpen));
          sibiling.inert = !isOpen;
        };
        renderFaq();
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const opening = item.dataset.open !== 'true';
          item.dataset.open = String(opening);
          this.scrollToEl = opening ? parent : undefined;
          renderFaq();
        });
        window.addEventListener('resize', renderFaq);
        return;
      }

      if (item.dataset.open === 'true') {
        parent.style.maxHeight = height + sibilingHeight + 'px';
        item.classList.add('activeClass');
      }

      item.addEventListener('click', (e) => {
        e.preventDefault();

        if (item.dataset.open === 'false') {
          this.scrollToEl = parent;
          item.dataset.open = 'true';
          parent.style.maxHeight = height + sibilingHeight + 'px';
          item.classList.add('activeClass');
          item.parentElement?.classList.add('activeClass');
        } else {
          this.scrollToEl = undefined;
          item.dataset.open = 'false';
          parent.style.maxHeight = height + 'px';
          item.classList.remove('activeClass');
          item.parentElement?.classList.remove('activeClass');
        }
      });
    });
  },
  setMultipleToggle(item: HTMLElement, items: NodeListOf<HTMLElement>) {
    const expendAll = item.querySelector('.jsAccordianExpandOpenAll') as
      | HTMLElement
      | undefined;
    const closeAll = item.querySelector('.jsAccordianCollapseAll') as
      | HTMLElement
      | undefined;

    expendAll?.addEventListener('click', () => {
      expendAll.classList.add('activeClass');
      closeAll?.classList.remove('activeClass');
      this.openAll(items);
    });
    expendAll?.click();
    closeAll?.addEventListener('click', () => {
      closeAll.classList.add('activeClass');
      expendAll?.classList.remove('activeClass');
      this.closeAll(items);
    });
  },
  closeAll(items: NodeListOf<HTMLElement>) {
    items.forEach((item) => {
      const parent = item.parentElement as HTMLElement;
      const height = item.offsetHeight;
      item.dataset.open = 'false';
      parent.style.maxHeight = height + 'px';
      item.classList.remove('activeClass');
    });
  },
  openAll(items: NodeListOf<HTMLElement>) {
    items.forEach((item) => {
      const parent = item.parentElement as HTMLElement;
      const sibiling = item.nextElementSibling as HTMLElement;
      const sibilingHeight = sibiling.offsetHeight;
      const height = item.offsetHeight;
      item.dataset.open = 'true';
      parent.style.maxHeight = height + sibilingHeight + 'px';
      item.classList.add('activeClass');
    });
  },
  scrollPosition(offset: string) {
    if (this.scrollToEl) {
      window.scrollTo({
        top: this.scrollToEl.offsetTop - +offset,
        behavior: 'smooth',
      });
    }
  },
};

export default accordian;
